import dayjs from 'dayjs';
import React from 'react';
import Select from 'react-select';

export default function FormPeriodos({item, errors, periodosAcademicos}) {
    return (<>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Nombre:
                </label>
            </div>
            <div className='col col-md-7'>
                <input
                    type='text'
                    className='text-input form-control'
                    id='nombre'
                    name='nombre'
                    defaultValue={item.nombre}
                />
                {errors.nombre && (
                    <small className='help-blockParams form-Text'>
                        {errors.nombre[0]}
                    </small>
                )}
            </div>
        </div>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Código/Alias:
                </label>
            </div>
            <div className='col col-md-7'>
                <input
                    type='text'
                    className='text-input form-control'
                    id='codigo'
                    name='codigo'
                    defaultValue={item.codigo}
                />
                {errors.codigo && (
                    <small className='help-blockParams form-Text'>
                        {errors.codigo[0]}
                    </small>
                )}
            </div>
        </div>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Año Escolar:
                </label>
            </div>
            <div className='col col-md-7'>
                <Select
                    name='periodo_academico_id'
                    options={periodosAcademicos && periodosAcademicos.map(p => ({
                        label: p.nombre,
                        value: p.id,
                    }))}
                    defaultValue={{
                        label: item.periodoAcademico?.nombre,
                        value: item.periodoAcademico?.id
                    }}
                />
                {errors.periodo_academico_id && (
                    <small className='help-blockParams form-Text'>
                        {errors.periodo_academico_id[0]}
                    </small>
                )}
            </div>
        </div>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Categoría:
                </label>
            </div>
            <div className='col col-md-7'>
                <input
                    type='text'
                    className='text-input form-control'
                    id='categoria'
                    name='categoria'
                    defaultValue={item.categoria}
                />
                {errors.categoria && (
                    <small className='help-blockParams form-Text'>
                        {errors.categoria[0]}
                    </small>
                )}
            </div>
        </div>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Fecha Inicio:
                </label>
            </div>
            <div className='col col-md-7'>
                <input
                    type='date'
                    className='text-input form-control'
                    id='fecha_inicio'
                    name='fecha_inicio'
                    defaultValue={item.fechaInicio && dayjs(item.fechaInicio).format('YYYY-MM-DD')}
                />
                {errors.fecha_inicio && (
                    <small className='help-blockParams form-Text'>
                        {errors.fecha_inicio[0]}
                    </small>
                )}
            </div>
        </div>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Fecha Cierre:
                </label>
            </div>
            <div className='col col-md-7'>
                <input
                    type='date'
                    className='text-input form-control'
                    id='fecha_cierre'
                    name='fecha_cierre'
                    defaultValue={item.fechaCierre && dayjs(item.fechaCierre).format('YYYY-MM-DD')}
                />
                {errors.fecha_cierre && (
                    <small className='help-blockParams form-Text'>
                        {errors.fecha_cierre[0]}
                    </small>
                )}
            </div>
        </div>
        <div className='row form-group'>
            <div className='col col-md-5'>
                <label className='label form-control-label'>
                    Estado:
                </label>
            </div>
            <div className='col col-md-7'>
                <select className='form-control' name="estado" defaultValue={item.estado}>
                    <option value="activo">Activo</option>
                    <option value="pendiente">Pendiente</option>
                    <option value="inactivo">Inactivo</option>
                    <option value="cerrado">Cerrado</option>
                </select>
                {errors.estado && (
                    <small className='help-blockParams form-Text'>
                        {errors.estado[0]}
                    </small>
                )}
            </div>
        </div>
    </>)
}
